// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';

export const DeletedOut = zod.object({
  "deleted": zod.int()
});

export type DeletedOut = zod.input<typeof DeletedOut>;
export type DeletedOutOutput = zod.output<typeof DeletedOut>;
